import React, { useLayoutEffect, useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from './Layouts/Header';
import Footer from './Layouts/Footer';
import InquiryModal from './InquiryModal';
import { fetchServices } from '../utils/apiService';

// Default fallback image
import img4 from '../assets/image/img-4.jpg';

const Services = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedService, setSelectedService] = useState('');
    const [services, setServices] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    useLayoutEffect(() => {
        // Trigger animations for this section
        const timer = setTimeout(() => {
            if (window.animationText) window.animationText();
            if (window.scrollingEffect) window.scrollingEffect();
            if (window.animateImgItem) window.animateImgItem();

            // Refresh ScrollTrigger as content might have changed
            if (window.ScrollTrigger) {
                window.ScrollTrigger.refresh();
            }
        }, 100);

        return () => {
            clearTimeout(timer);
            if (window.revertAnimations) window.revertAnimations();
            if (window.revertHeadline) window.revertHeadline();
        };
    }, [services]);

    useEffect(() => {
        const getServices = async () => {
            setIsLoading(true);
            const result = await fetchServices();
            if (result && result.status && result.data) {
                // Sort services by sort_order
                const sortedServices = [...result.data].sort((a, b) => {
                    const orderA = a.sort_order || 0;
                    const orderB = b.sort_order || 0;
                    return orderA - orderB;
                });
                setServices(sortedServices);
            }
            setIsLoading(false);
        };
        getServices();
    }, []);

    const openModal = (service) => {
        setSelectedService(service);
        setIsModalOpen(true);
    };

    const getImageUrl = (imgVal) => {
        if (!imgVal) return img4; // Fallback
        const imgStr = imgVal.toString().trim();
        return imgStr.startsWith('http')
            ? imgStr
            : `${process.env.REACT_APP_STORAGE_BASE_URL || 'http://localhost:8000/storage'}/${imgStr}`;
    };

    return (
        <div className="wrapper position-relative">
            <Header />

            <div className="page-title">
                <div className="tf-container">
                    <div className="page-title-content text-center">
                        <h1 className="title" dangerouslySetInnerHTML={{ __html: '<span class="split-text effect-right">Services</span>' }} />
                        <div className="breadkcum">
                            <Link to="/" className="link-breadkcum body-2 fw-7">
                                <span className="split-text effect-right" dangerouslySetInnerHTML={{ __html: 'Home' }} />
                            </Link>
                            <span className="dot"></span>
                            <span className="page-breadkcum body-2 fw-7">
                                <span className="split-text effect-right" dangerouslySetInnerHTML={{ __html: 'Services' }} />
                            </span>
                        </div>
                    </div>
                </div>
            </div>

            <div className="main-content">
                <section className="section-services p-services tf-spacing-2">
                    <div className="tf-container">
                        {isLoading ? (
                            <div className="text-center py-5">
                                <p>Loading services...</p>
                            </div>
                        ) : services.length === 0 ? (
                            <div className="text-center py-5">
                                <p>No services available at the moment.</p>
                            </div>
                        ) : (
                            <div className="list-services flex flex-wrap">
                                {services.map((service) => (
                                    <div key={service.id} className="services-item hover-image px-lg-15 no-img inner-service">
                                        <div className="icon">
                                            <img src={getImageUrl(service.icon)} alt="icon" />
                                        </div>

                                        <h5
                                            className="lh-30 fw-6"
                                            dangerouslySetInnerHTML={{
                                                __html: `<a href="javascript:void(0)" class="title-service">${service.title}</a>`
                                            }}
                                        />

                                        <a href="javascript:void(0)" className="image">
                                            <img
                                                src={getImageUrl(service.image)}
                                                alt={service.title}
                                                className="ls-is-cached lazyloaded"
                                            />
                                        </a>

                                        <div
                                            className="desc lh-30"
                                            dangerouslySetInnerHTML={{ __html: service.description }}
                                        />

                                        <div className="bottom-item">
                                            <button
                                                className="tf-btn-readmore"
                                                onClick={() => openModal(service.title)}
                                                style={{ border: 'none', background: 'none', padding: 0 }}
                                            >
                                                <span className="plus">+</span>
                                                <span className="text">Inquiry Now</span>
                                            </button>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                </section>
            </div>
            <Footer />
            <InquiryModal
                isOpen={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                initialService={selectedService}
            />
        </div>
    );
};

export default Services;